// Datos estáticos del sitio Autodestrucción S.A.

export const SITE_META = {
    name: "El Mapa Inverso",
    siteTitle: "El Mapa Inverso — Sobriedad con sentido",
    tagline: "Sobriedad con sentido — cómo convertir la autodestrucción en un camino de vida.",
    foundedYears: 20,
    authorName: "Nelson González Rodríguez",
    authorHandle: "@nitanadicto",
    contactEmail: "nomeofrezcasdroga@nitanadicto.com",
    socials: {
        instagram: "https://www.instagram.com/sinadicciones_org",
        tiktok: "https://www.tiktok.com/@nitanadicto",
        youtube: "https://www.youtube.com/@nitanadicto",
        linkedin: "https://www.linkedin.com/in/nelsongonzalezr/",
        original: "https://nitanadicto.com",
        sinAdicciones: "https://sinadicciones.org",
        libroSina: "https://www.sinadicciones.org/libro",
        elMapaInverso: "https://elmapainverso.com/descargar",
        planSobrio: "https://plansobrio.com",
        cuentosParaAdictos: "https://www.sinadicciones.org/cuentos-para-adictos",
        herramientasGratuitas: "https://www.sinadicciones.org/herramientas",
    },
    avatarUrl:
        "https://customer-assets.emergentagent.com/job_autodestruccion-sa/artifacts/96mtdjwo_image.png",
    portraitUrl:
        "https://customer-assets.emergentagent.com/job_autodestruccion-sa/artifacts/e20qonn4_image.png",
};

// ----------------------------------------------------------------
// CUENTOS PARA ADICTOS — serie escrita por Nelson (4 cuentos)
// Data extraída de sinadicciones.org/cuentos-para-adictos
// ----------------------------------------------------------------
export const CUENTOS = [
    {
        slug: "la-casa-de-los-lobos",
        title: "La casa de los lobos",
        subtitle: "Un cuento sobre adicción, heridas y recuperación",
        cover: "https://www.sinadicciones.org/cuentos/portadas/la-casa-de-los-lobos.png",
        pitch: "La historia de los dos lobos termina diciendo que gana el que alimentas. ¿Y qué hago con el otro? Un cuento sobre convivir con la parte de ti que no se va.",
        forWhom: "Personas en recuperación, en cualquier etapa. También para quien nunca ha tenido una adicción pero convive con una parte de sí mismo que no sabe manejar.",
        url: "https://www.sinadicciones.org/cuentos-para-adictos/la-casa-de-los-lobos",
        audience: "personal",
    },
    {
        slug: "el-ultimo-barco",
        title: "El último barco",
        subtitle: "Un cuento sobre adicción, decisiones y la vida que elegimos no abandonar",
        cover: "https://www.sinadicciones.org/cuentos/portadas/el-ultimo-barco.png",
        pitch: "\"Quemar las naves\" suena definitivo. Pero en la orilla siempre queda madera, y uno sabe construir. Un cuento sobre la decisión que hay que tomar de nuevo.",
        forWhom: "Personas con tiempo en recuperación. Especialmente para quien ya tomó la decisión grande y descubrió que había que volver a tomarla.",
        url: "https://www.sinadicciones.org/cuentos-para-adictos/el-ultimo-barco",
        audience: "personal",
    },
    {
        slug: "la-ciudad-de-las-puertas",
        title: "La ciudad de las puertas",
        subtitle: "Un cuento sobre craving, decisiones y los caminos que empiezan mucho antes de cruzar",
        cover: "https://www.sinadicciones.org/cuentos/portadas/la-ciudad-de-las-puertas.png",
        pitch: "\"Evita personas, lugares y cosas\" es buen consejo. ¿Y cuando el lugar es la ciudad donde vives? Un cuento sobre el craving y las decisiones que lo preceden.",
        forWhom: "Cualquiera que haya sentido unas ganas que aparecieron sin anunciarse y no entienda de dónde salieron. Útil también para familiares que quieren entender qué es el craving.",
        url: "https://www.sinadicciones.org/cuentos-para-adictos/la-ciudad-de-las-puertas",
        audience: "personal",
    },
    {
        slug: "papa-que-es-un-adicto",
        title: "Papá, ¿qué es un adicto?",
        subtitle: "Un cuento sobre lo que vemos, lo que no vemos y la importancia de hablar",
        cover: "https://www.sinadicciones.org/cuentos/portadas/papa-que-es-un-adicto.png",
        pitch: "Un niño de trece años le pregunta a su papá qué es un adicto. Un cuento para leer en familia sobre los prejuicios que aprendemos sin preguntar.",
        forWhom: "Padres, madres y cuidadores que no saben cómo hablar de adicciones con niños y adolescentes. Se puede leer juntos.",
        url: "https://www.sinadicciones.org/cuentos-para-adictos/papa-que-es-un-adicto",
        audience: "family",
    },
];

// ----------------------------------------------------------------
// PROYECTOS DE NELSON — links oficiales para la sección bio + Author schema
// ----------------------------------------------------------------
export const NELSON_LINKS = [
    {
        key: "sinadicciones",
        label: "SinAdicciones.org",
        blurb: "Plataforma que conecta a familias con tratamiento verificado en Latinoamérica.",
        url: "https://sinadicciones.org",
    },
    {
        key: "libro-sina",
        label: "Libro · Mapa Inverso (SinAdicciones)",
        blurb: "El libro publicado dentro del ecosistema SinAdicciones.org.",
        url: "https://www.sinadicciones.org/libro",
    },
    {
        key: "elmapainverso",
        label: "elmapainverso.com",
        blurb: "Descarga directa del libro y ecosistema editorial.",
        url: "https://elmapainverso.com/descargar",
    },
    {
        key: "plansobrio",
        label: "PlanSobrio.com",
        blurb: "Plataforma en español para conectar personas en recuperación o que viven sobrias.",
        url: "https://plansobrio.com",
    },
    {
        key: "cuentos",
        label: "Cuentos para adictos",
        blurb: "Narrativa breve para adictos y sus familias — herramienta de introspección.",
        url: "https://www.sinadicciones.org/cuentos-para-adictos",
    },
    {
        key: "herramientas",
        label: "Herramientas gratuitas",
        blurb: "Tests de autoevaluación, calculadora de costos, orientación confidencial y comunidad web.",
        url: "https://www.sinadicciones.org/herramientas",
    },
    {
        key: "linkedin",
        label: "LinkedIn · Nelson González R.",
        blurb: "Perfil profesional y proyectos actuales.",
        url: "https://www.linkedin.com/in/nelsongonzalezr/",
    },
];

// ----------------------------------------------------------------
// EL LIBRO — metadatos editoriales
// ----------------------------------------------------------------
export const LIBRO = {
    title: "El Principio del Mapa Inverso",
    subtitle: "Sobriedad con sentido: cómo convertir la autodestrucción en un camino de vida",
    author: "Nelson González R.",
    edition: "Primera edición · 2026",
    language: "Español · Chile",
    format: "Digital (PDF + EPUB)",
    priceCLP: 0,
    priceLabel: "Gratis · sin condiciones",
    sku: "EMI-2026-001",
    isbn: null,
    coverUrl:
        "https://customer-assets.emergentagent.com/job_autodestruccion-sa/artifacts/7f64aa5m_libro%20portada.png",
    elevator: `Durante más de veinte años construí una vida alrededor de la adicción: consumo, recaídas, comisarías, centros de rehabilitación y promesas que siempre terminaban rompiéndose. Creí que solo había dejado pérdidas. Después entendí que también había dejado señales.\n\nLa ruta que me llevó al fondo, leída al revés, podía mostrarme el camino de vuelta.\n\nEste libro es ese mapa.`,
    pitch: [
        "No es un manual clínico. No es una fórmula. No reemplaza terapia.",
        "Es un mapa: el de la destrucción, leído al revés.",
        "Si te reconoces en la primera página, el resto es para ti.",
    ],
    chapters: [
        {
            part: "PARTE I — La caída",
            items: [
                { n: 1, title: "Nombrar el vacío" },
                { n: 2, title: "Alcohol, mi primera droga" },
                { n: 3, title: "Autodestrucción S.A." },
                { n: 4, title: "Comisarías, clínicas y desayunos de cocaína" },
                { n: 5, title: "Cuando pedir ayuda no basta" },
            ],
        },
        {
            part: "PARTE II — Los centros",
            items: [
                { n: 6, title: "Primer centro de rehabilitación" },
                { n: 7, title: "El centro caro tampoco me salvó" },
                { n: 8, title: "Fui drogado al ambulatorio" },
            ],
        },
        {
            part: "PARTE III — Los patrones",
            items: [
                { n: 9, title: "La trampa de sentirme bien" },
                { n: 10, title: "La recaída no empieza con la sustancia" },
                { n: 11, title: "Pasta base: cuando el fondo tiene sótano" },
                { n: 12, title: "La familia también se enferma de tu consumo" },
            ],
        },
        {
            part: "PARTE IV — La reconstrucción",
            items: [
                { n: 13, title: "Rendirse para vivir" },
                { n: 14, title: "No es voluntad, es sistema" },
                { n: 15, title: "Sobriedad con sentido" },
                { n: 16, title: "El Mapa Inverso" },
            ],
        },
    ],
    quotes: [
        "Tu destrucción tiene patrones. Hay rutas que se repiten antes de cada caída, frases que te dices antes de cada mentira y emociones que simplemente no sabes habitar.",
        "El mapa que te llevó al infierno también puede sacarte, porque ese mapa es tu historia.",
        "La adicción no te pide que recaigas. Te convence de que no necesitas ayuda. Eso es más difícil de resistir.",
        "No se trata solo de dejar de consumir. Se trata de dejar de necesitar destruirte para sentir que existes.",
        "Si tu manera te estrelló siempre en el mismo lugar, rendirse a la ayuda externa no es perder. Es empezar a pensar con honestidad por primera vez.",
    ],
    intro: `Me desperté en el suelo de una comisaría. El frío venía del cemento, no del aire. La luz de la mañana entraba por una ventana pequeña y picaba en los ojos.\n\nEso fue todo.\n\nNo había poesía en eso.\n\nTengo 42 años. Tres hijos. Una empresa. Y una historia que todavía me cuesta contar. La cuento igual.\n\nEste libro no trata sobre cómo construí una vida. Trata sobre cómo la adicción fue levantando otra encima: una vida paralela, hecha de consumo, mentiras, escondites, recaídas y promesas rotas.\n\nDurante más de veinte años destruí todo lo que toqué. No de golpe. De a poco. Metódicamente. Cambié de droga, de ciudad, de compañía y de discurso, pero la ruta siempre terminaba en el mismo lugar.\n\nDurante mucho tiempo pensé que solo era una colección de cagadas.\n\nDespués entendí algo que me habría ahorrado años de desastre: la destrucción también tiene patrones. Hay emociones, personas, lugares, pensamientos y silencios que aparecen antes de cada caída.\n\nY donde hay patrones, hay un mapa.\n\nEl mismo mapa que te llevó al fondo puede, leído al revés, mostrarte el camino de vuelta.\n\nEste libro no promete salvarte. No reemplaza un tratamiento ni la ayuda profesional. Pero puede ayudarte a reconocer las señales que quizás llevas años ignorando.\n\nLa destrucción deja un mapa. Aprender a leerlo puede cambiar el rumbo.`,
    forWhom: [
        "Para ti, que quizás hoy te miraste al espejo y no reconociste a la persona que te devolvía la mirada.",
        "Para ti, que has prometido 'esta es la última vez' más veces de las que puedes contar.",
        "Para el que ama a alguien que se está perdiendo y ya no sabe si intentar salvarlo es un acto de amor o seguir financiando su caída.",
        "Y también para ti, que, aunque hoy estés sobrio, por dentro todavía hay una carretera vieja llamándote por tu nombre.",
    ],
    deliverables: [
        "PDF + EPUB descargables al instante",
        "Acceso por email seguro",
        "Lectura en cualquier dispositivo",
        "Sin DRM agresivo · uso personal",
    ],
};

export const HOME_ECOSYSTEM = [
    {
        slug: "mapa-inverso",
        codeName: "EMI-01 / APP",
        title: "Mapa Inverso · interactivo",
        kicker: "Herramienta gratis",
        blurb: "Construye tu propio Mapa Inverso en 9 pasos guiados. Salida con plan de acción y guía AI personalizada.",
        to: "/mapa-inverso",
        cta: "Empezar gratis",
        accent: "warning",
    },
    {
        slug: "autodestruccion-sa",
        codeName: "EMI-02 / CAP. 3",
        title: "Autodestrucción S.A.",
        kicker: "Capítulo en vivo",
        blurb: "El capítulo 3 del libro, montado como empresa satírica con productos, planes, equipo y testimonios.",
        to: "/autodestruccion-sa",
        cta: "Entrar al capítulo",
        accent: "danger",
    },
    {
        slug: "antipoesia",
        codeName: "EMI-03 / ARCHIVO",
        title: "Antipoesía + Glosario",
        kicker: "Espejos en bruto",
        blurb: "134 antipoesías y un glosario de 97 términos. La poesía que la RAE nunca se atrevió a escribir.",
        to: "/antipoesia",
        cta: "Leer fragmentos",
        accent: "paper",
    },
    {
        slug: "archivo",
        codeName: "EMI-04 / BLOG",
        title: "Archivo de Cicatrices",
        kicker: "Entradas",
        blurb: "Textos largos, mensajes iniciáticos y el currículum del autoengaño. Notas escritas con la herida abierta.",
        to: "/blog",
        cta: "Explorar archivo",
        accent: "muted",
    },
];

export const PRODUCTS = [
    {
        slug: "alcohol",
        name: "Alcohol",
        codeName: "AD-001 / GATEWAY",
        role: "Director de Apertura",
        image: "https://static.prod-images.emergentagent.com/jobs/de6319bd-d7d5-491d-8795-5d9a80349b66/images/28a67f132966f13c420313b79ffe3e05bd840318027784e72869bdd66e8d6cce.png",
        tagline: "Encargado de abrir la puerta a todo lo que vino después.",
        description:
            "Maestro en disfrazarse de celebración mientras prepara la caída. Aporta valor líquido, valentía prestada y memoria selectiva.",
        warning: "Riesgo: alto. Disfrazado de social.",
    },
    {
        slug: "cocaina",
        name: "Cocaína",
        codeName: "AD-002 / ELEGANTE",
        role: "Vendedora de Espejismos",
        image: "https://static.prod-images.emergentagent.com/jobs/de6319bd-d7d5-491d-8795-5d9a80349b66/images/46b8717d26daf401c2d2f0a205c8638c3f65178bc41eb431e07b29705e50505a.png",
        tagline: "La mentira más elegante del catálogo.",
        description:
            "Promete energía, seguridad y conexión. Cobra con ansiedad, paranoia y dignidad. Brilla en los primeros diez minutos. Después no brilla nadie.",
        warning: "Riesgo: alto. Cobra siempre.",
    },
    {
        slug: "pasta-base",
        name: "Pasta Base",
        codeName: "AD-003 / TERMINAL",
        role: "Reductora de Potencial",
        image: "https://static.prod-images.emergentagent.com/jobs/de6319bd-d7d5-491d-8795-5d9a80349b66/images/c49bc46ea4d695493904e683a412e67cd95356a7ebdb44c62a256be0cd15ca64.png",
        tagline: "Experta en reducir el potencial humano al mínimo vital.",
        description:
            "Aporta foco absoluto en la nada, insomnio garantizado y una maestría única en transformar esperanza en ceniza.",
        warning: "Riesgo: terminal. No hay versión light.",
    },
    {
        slug: "compania-rota",
        name: "Compañía Rota",
        codeName: "AD-004 / PLACEBO",
        role: "Encargada de Intimidad Simulada",
        image: "https://static.prod-images.emergentagent.com/jobs/de6319bd-d7d5-491d-8795-5d9a80349b66/images/c7b4af779ac603cbb862ca6b91f43d458214618167d685ad483e651fa311a4f4.png",
        tagline: "Abraza sin preguntar, escucha sin importar.",
        description:
            "Aporta el espejismo perfecto de intimidad cuando la soledad grita demasiado fuerte. Su trabajo: llenar el vacío, al menos lo intentó.",
        warning: "Riesgo: emocional. Subraya la soledad.",
    },
];

export const PLANES = [
    {
        slug: "inicio",
        code: "PLAN 01",
        name: "Inicio",
        tagline: "Ideal para quienes quieren experimentar.",
        bullets: [
            "Pérdida de concentración y clases",
            "Consumo de más de un día",
            "Primeros conflictos familiares",
            "Sensación de impunidad temporal",
            "Promesas de control que aún se creen",
        ],
        cta: "Leer la advertencia",
        ctaPath: "/salida",
        priceLabel: "Gratis al principio",
        priceSub: "Se paga después, con intereses.",
    },
    {
        slug: "profesional",
        code: "PLAN 02",
        name: "Profesional",
        tagline: "Para quienes quieren llevarlo pro.",
        bullets: [
            "Todo lo del Plan 01",
            "Primeras recaídas",
            "Problemas legales o peleas",
            "Búsqueda de compañía vacía",
            "Deterioro de relaciones",
            "No llegar a fin de mes",
        ],
        cta: "Ver el daño",
        ctaPath: "/salida",
        priceLabel: "Tu sueldo + algo más",
        priceSub: "Y un poco de la confianza de otros.",
        featured: true,
    },
    {
        slug: "sin-retorno",
        code: "PLAN 03",
        name: "Sin Retorno",
        tagline: "Para quienes ya dejaron que el sistema administre su vida.",
        bullets: [
            "Todo lo de los planes 01 y 02",
            "Consumo diario o dependencia",
            "Pérdida de empleo o negocios",
            "Deudas, robos o estafas",
            "Tolerancia y angustia constante",
            "Ideación suicida",
            "Vacío asegurado",
        ],
        cta: "Buscar salida",
        ctaPath: "/salida",
        priceLabel: "Todo lo que tengas",
        priceSub: "Y todo lo que aún no sabes que pierdes.",
    },
];

export const EQUIPO = [
    {
        name: "Director de Evasión",
        person: "Yo, a las 3 AM",
        bio: "Especialista en huir de sí mismo con eficiencia operativa. 20 años en el cargo.",
        kpi: "1.247 huidas / año",
    },
    {
        name: "Gerente de Excusas",
        person: "El Yo Funcional",
        bio: "Desarrollo de justificaciones creativas para seguir igual. Métricas de repetición semanal.",
        kpi: "98% retención",
    },
    {
        name: "Manager en Recaídas",
        person: "El Yo del Jueves",
        bio: "Promesas de lunes, recaídas de jueves, culpa de domingo. Operación 24/7.",
        kpi: "365 ciclos / año",
    },
    {
        name: "Jefe de Finanzas del Caos",
        person: "El Yo sin sueldo",
        bio: "Transforma dinero, oportunidades y vínculos en consumo. Balance siempre rojo.",
        kpi: "ROI -100%",
    },
    {
        name: "Encargado de Relaciones Tóxicas",
        person: "El Yo que no se mira",
        bio: "Busca compañía rota para no mirar el espejo completo. Especialista en codependencia.",
        kpi: "0 vínculos sanos",
    },
    {
        name: "Becario de Promesas",
        person: "El Yo de 'mañana parto'",
        bio: "Entrega diaria de promesas vacías al equipo ejecutivo. Cumplimiento: 0%.",
        kpi: "Sin cumplir",
    },
];

export const GLOSARIO_INTRO = {
    eyebrow: "Diccionario interno · 06",
    subtitle: "Definiciones que la RAE nunca se atrevió a escribir.",
    paragraphs: [
        "Durante 20 años de consumo, aprendí que las palabras no significan lo mismo cuando estás al borde.",
        "La RAE dice una cosa; la calle, otra; y el cerebro, en dopamina, otra muy distinta.",
        "Este glosario no busca enseñar ni moralizar. Busca traducir.",
        "Porque entre pipas, recaídas y moteles, uno termina inventando su propio idioma. Y entenderlo fue el primer paso para dejar de repetirlo.",
    ],
    readingTime: "5–8 minutos",
    date: "1 nov 2025",
};

export const GLOSARIO_OUTRO = {
    title: "La RAE tiene razón en casi todo.",
    body: "Pero en la adicción, las palabras cambian de sentido.",
    examples: [
        { word: "vida", meaning: "seguir intentando" },
        { word: "recuperación", meaning: "recordar sin consumir" },
        { word: "dignidad", meaning: "volver a mirarte al espejo sin miedo" },
    ],
    closing:
        "Si te reíste, te dolió o te sentiste expuesto, tranquilo. Ya empezó la terapia.",
};

// Trigger warning para la página de antipoesía
export const ANTIPOESIA_WARNING = {
    title: "Antes de entrar al archivo",
    body: `Estos fragmentos hablan sin maquillaje de adicción, consumo, recaídas, compañía rota, abuso, autolesión, ideación suicida, violencia y rehabilitación. No buscan glorificar, sino testimoniar. Si estás en proceso o vienes de una herida reciente, considera leer acompañado/a o tomarlo en dosis pequeñas.`,
    quote: "Si te refleja, te duele o te hace espejo — bienvenido a la terapia.",
    continueLabel: "Entendido · continuar",
    exitLabel: "Llévame a la salida",
};


export const CURRICULUM = {
    cargo: "Director General de Promesas Rotas — Autodestrucción S.A.",
    antiguedad: "20 años (sin pausas reales, solo intermitencias).",
    experiencia: [
        "Maestría en huir de mí mismo con eficiencia operativa.",
        "Desarrollo creativo de excusas con métricas semanales de repetición.",
        "Negociación avanzada con la moral en horarios no laborales.",
        "Especialista en construir relaciones tóxicas con KPIs de codependencia.",
        "Liderazgo en sabotaje propio bajo presión.",
    ],
    habilidades: [
        { name: "Memoria selectiva", level: 100 },
        { name: "Justificación post-recaída", level: 95 },
        { name: "Gestión de culpa los domingos", level: 70 },
        { name: "Idioma materno: el silencio", level: 100 },
        { name: "Ducharse sin recaer", level: 30 },
    ],
    logros: [
        "Premio 'Promesa Rota del Año' — 14 ediciones consecutivas.",
        "Reconocimiento por destruir vínculos significativos en tiempo récord.",
        "Tres ascensos al fondo. Sin retorno garantizado.",
    ],
    educacion: [
        "Universidad de la Calle, Facultad de Excusas.",
        "Doctorado en negarme a ver lo evidente.",
        "Diplomado en confundir intensidad con amor.",
    ],
    referencias: "Disponibles bajo demanda. La mayoría ya no contesta el teléfono.",
};

export const KPIS = [
    { number: "20", label: "Años de experiencia destructiva" },
    { number: "1.247", label: "Recaídas operadas" },
    { number: "0", label: "Devoluciones aceptadas" },
    { number: "24/7", label: "Disponibilidad sin soporte emocional" },
];
